<script setup lang="ts">
import { Link, usePage } from "@inertiajs/vue3"

import Heading from "@/components/Heading.vue"
import { Button } from "@/components/ui/button"
import { Separator } from "@/components/ui/separator"
import {
  settingsAppearancePath,
  settingsProfilePath,
  settingsSessionsPath,
} from "@/routes"
import { type NavItem } from "@/types"

const sidebarNavItems: NavItem[] = [
  {
    title: "Profile",
    href: settingsProfilePath(),
  },
  {
    title: "Sessions",
    href: settingsSessionsPath(),
  },
  {
    title: "Appearance",
    href: settingsAppearancePath(),
  },
]

const page = usePage()
</script>

<template>
  <div class="px-4 py-6">
    <Heading
      class="mb-8"
      title="Settings"
      description="Manage your profile and account settings"
    />

    <div class="flex flex-col lg:flex-row lg:space-x-12">
      <aside class="w-full max-w-xl lg:w-48">
        <nav class="flex flex-col space-y-1 space-x-0">
          <Button
            v-for="item in sidebarNavItems"
            :key="item.href"
            variant="ghost"
            :class="[
              'w-full justify-start',
              { 'bg-muted': page.url === item.href },
            ]"
            as-child
          >
            <Link :href="item.href">
              {{ item.title }}
            </Link>
          </Button>
        </nav>
      </aside>

      <Separator class="my-6 lg:hidden" />

      <div class="w-full flex-1 md:max-w-2xl">
        <section class="space-y-12">
          <slot />
        </section>
      </div>
    </div>
  </div>
</template>
